// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8uMsY","selected":"styles_selected__32tEI"};